import { useTitle } from "react-use";

function usePageTitle(title: string) {
  useTitle(`پنل مدیریت | ${title}`);

  return null;
}

export default usePageTitle;
